export default __webpack_public_path__ + "static/firstrings-169df0a8e1b9bf37d82162e755d148c1.png";